const InputWrapper = ({ labelName, ...props }) => {
  return (
    <div>
      <label htmlFor={props.id} className="sr-only">
        {props.placeholder}
      </label>
      <input {...props} />
    </div>
  );
};

export default InputWrapper;
